













import Vue from 'vue';
import _ from 'lodash';
import isGranted from '../../auth/isGranted';
import { subscribe, unsubscribe } from '.';
import { AccountSubscriber } from '../../types';

interface Data {
  task: Promise<void>|Promise<AccountSubscriber>|null,
  loading: boolean,
}

export default Vue.extend({
  props: {
    accountId: {
      type: String,
      required: true,
    },
    userId: {
      type: String,
      required: true,
    },
    accountSubscriberId: String,
  },
  data(): Data {
    return {
      task: null,
      loading: false,
    };
  },
  watch: {
    task: {
      handler(newTask): void {
        if (!newTask) return;
        this.loading = true;
        newTask.finally(() => {
          this.loading = false;
        });
      },
      immediate: true,
    },
  },
  computed: {
    value(): boolean {
      return !_.isNil(this.accountSubscriberId);
    },
  },
  methods: {
    toggle(value: boolean): void {
      if (value) {
        this.subscribe();
      } else {
        this.unsubscribe();
      }
    },
    subscribe(): void {
      this.task = subscribe(this.accountId, this.userId);
      this.task.then((subscriber: AccountSubscriber) => {
        this.$emit('subscribed', subscriber);
      });
    },
    unsubscribe(): void {
      if (!this.accountSubscriberId) return;
      this.task = unsubscribe(this.accountSubscriberId);
      this.task.then(() => {
        this.$emit('unsubscribed', this.userId);
      });
    },
    isGranted,
  },
});
